<template>
  <div class="biljeske-tags folder-type-filter">
    <div
      class="biljeske-tag"
      :class="{ active: selected_folder_filter.name == single_ff.name }"
      v-for="single_ff in folder_filters"
      :key="single_ff.name"
      @click="selected_folder_filter = single_ff"
    >
      {{ $t('components.file_management.folderFilter.' + single_ff.name) }}
    </div>
  </div>
</template>

<script>
import { DEFAULT_CASE_FOLDERS } from "../../helpers/default_vals/enums";
export default {
  props: {
    filter: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
    //   folder_filters: DEFAULT_CASE_FOLDERS,
      selected_folder_filter: DEFAULT_CASE_FOLDERS[0],
    };
  },
  watch: {
    selected_folder_filter() {
      this.$emit("changedValue", this.selected_folder_filter);
    },
  },
  computed: {
    folder_filters() {
      if (this.filter == 1) { // every folder is available
        return DEFAULT_CASE_FOLDERS
      }
      else if(this.filter == 0){
        //Only working type folders
        
        return DEFAULT_CASE_FOLDERS.filter(p=> p.file_type_allowed != ".pdf")
      }
    },
  },
};
</script>

<style></style>